/**
 * @file 新手教程页页面路由
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';
import Tutorials from './Tutorials';

const TutorialsRoute: React.FC = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/tutorials/projectdetail/:id" component={Tutorials} />
                <Route path="/tutorials/education/preview/:id" component={Tutorials} />
                <Route path="/tutorials/education/lessonvideo/:id" component={Tutorials} />
                <Route path="/tutorials" component={Tutorials} />
                <Redirect to="/tutorials" />
            </Switch>
        </BrowserRouter>
    );
};

export default TutorialsRoute;
